import {
  IDetailsResponse,
  IExternalDetailsResponse,
  IGeoSuggestExternalResponse,
  IGeoSuggestExternalResponseItem,
  IGeoSuggestResponse,
} from '@/services/geoSuggest/geoSuggest.types.ts'
import axios, { AxiosResponse } from 'axios'
import config from '@/config.ts'

const getSuggestions = async (search: string): Promise<IGeoSuggestExternalResponse> => {
  try {
    const resp: AxiosResponse<IGeoSuggestResponse> = await axios.get(
      `https://suggest-maps.yandex.ru/v1/suggest?apikey=${config.YANDEX_SUGGEST_KEY}&text=${search}&attrs=uri`
    )

    const respItems: IGeoSuggestExternalResponseItem[] = resp.data.results.map((r) => ({
      uri: r.uri,
      address: r.title.text,
      cityAndRegion: r.subtitle.text,
    }))

    return { results: respItems }
  } catch (err) {
    console.log(err)
    return { results: [] }
  }
}

const getSuggestDetails = async (uri: string): Promise<IExternalDetailsResponse> => {
  try {
    const resp: AxiosResponse<IDetailsResponse> = await axios.get(
      `https://geocode-maps.yandex.ru/1.x/?apikey=${config.YANDEX_GEOCODE_KEY}&uri=${uri}&format=json`
    )

    const respItem = resp.data.response.GeoObjectCollection.featureMember[0]
    const [lng, lat] = respItem.GeoObject.Point.pos.split(' ')
    return {
      lat,
      lng,
      kind: respItem.GeoObject.metaDataProperty.GeocoderMetaData.kind,
      address: respItem.GeoObject.metaDataProperty.GeocoderMetaData.text,
      аddressСomponents: respItem.GeoObject.metaDataProperty.GeocoderMetaData.Address.Components,
      postalCode: respItem.GeoObject.metaDataProperty.GeocoderMetaData.Address.postal_code,
    }
  } catch (err) {
    console.log(err)
    return null
  }
}

const geoSuggest = { getSuggestions, getSuggestDetails }
export default geoSuggest
